<style lang="scss" scoped>
#customerchat {
	.all_div{
		height: 34rem;
		color: #000000A6;
		background: pink;
		border-radius: 10px;
		display: flex;
	}
	.div_left{
		width: 15rem;
		flex-shrink: 0;
		height: 100%;
		overflow-y: auto;
		border-right: 1px solid #f1f1f1;
		background-color: #fff;
		border-radius: 10px 0 0 10px;
	}
	.div_left_seach{
		height: 3.5rem;
		display: flex;
		justify-content: center;
    	align-items: center;
		border-bottom: 1px solid #f1f1f1;
	}
	.div_left_list{
		height: 30.5rem;
		overflow-y: auto;
	}
	.div_left_list_strip{
		display: flex;
		padding: 0.8rem;
		border-bottom: 1px solid #f1f1f1;
	}
	.div_left_list_strip_num{
		position: absolute;
		right: 15px;
		background: red;
		border-radius: 50%;
		width: 0.8rem;
		height: 0.8rem;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
	}
	.div_right{
		width: 100%;
		height: 100%;
		background-color: #fff;
		border-radius: 0 10px  10px 0;
		overflow: auto;
		
	}
	.div_right_logo{
		height: 3.5rem;
		border-bottom: 1px solid #f1f1f1;
		display: flex;
		align-items: center;
		font-size: 1rem;
	}
	.div_right_chat{
		height: 20rem;
		border-bottom: 1px solid #f1f1f1;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 1rem;
	}

}

</style>
<template>
	<div>
		<a-modal v-show='!ishand' id='customerchat' width='50rem' v-model="visible" on-ok="handleOk1" v-dragModal @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file' style="overflow: hidden;width: 100%;">
			</div>
			<div class="all_div">
				<div class="div_left">
					<div class="div_left_seach">
						<a-input-search placeholder=" " v-model="username"  @search="onSearch" style="width: 13rem" />
					</div>
					<div class="div_left_list">
						<div class="div_left_list_strip" :style="{background: i == isrit_div ? '#f8f8f8' : ''}"  v-for='(v,i) in tablist' :key='i'  @click='handis(i)'>
							<div style="width: 25%;position: relative;flex-shrink: 0;">
								<div class="div_left_list_strip_num" v-if="v.noreadnum>0">{{v.noreadnum}}</div>
								<img :src="require('@/image/subscr/tou.png')" alt="" class='marngin_img' style="position: relative;top: .4rem;margin: 0;">
							</div>
							<div style="width: 7rem;flex-shrink: 0;">
								<div style="font-weight: 600;font-size: 0.8rem;">{{v.username}}</div>
								<div>{{v.finalMsg}}</div>
							</div>
							<div style="width: 100%;text-align: right;">
								{{v.astime}}
							</div>
							
						</div>
					</div>
				</div>
				<div class="div_right">
					<div class="div_right_logo">
						<img :src="require('@/image/subscr/kefu.png')" alt="" class='marngin_img' style="margin-left: 1rem; margin-right: 0.2rem"> Online Chat
					</div>
					<div class="div_right_chat" >
						<div v-for="item in tablelist" :key="item.key">
							<div  v-if="item.state_l" style="width: 100%;display: flex;justify-content: center;">
								<div style="text-align: center;padding: 3px 25px;
									background-color: #f5f5f5; font-size: 14px; border-radius: 5px;margin: 2rem 0 1rem ;
									color: #999;display: inline-block;" >
									{{item.dateval}}
								</div>
							</div>
							<div style="position: relative;display: flex;align-items: flex-start;margin-bottom: 1rem;" v-if='item.type==0'>
								<img :src="require('@/image/subscr/kehu1.png')" alt="" class='marngin_img' style="margin-right: 1rem;">
								<div style="width: 100%;"  v-if='item.msgtype == 1'>
									<div style="position: relative;display: inline-block;max-width: 43%;">
										<div v-html='item.message' style="display: inline-block;border: 1px solid #ececec;max-width: 100%;" @dblclick='handb(item)'  class='area_text'></div>
										<div class='bt_time' v-text='item.time'></div>
									</div>
								</div>
								<div style="width: 100%;" v-else>
									<div style="position: relative;display: inline-block;max-width: 43%;">
										<div class='area_text' v-html='item.message'></div>
										<div class='bt_time' v-text='item.time'></div>
									</div>
								</div>
							</div>

							<div style="position: relative;text-align: right;margin-bottom: 1rem;" v-if='item.type==1'>
								<div v-if='item.msgtype' v-html='item.message' style="display: inline-block;margin-right: 1rem;max-width: 100%;" @dblclick='handb(item)'  class='area_text_right'></div>
								<div v-else class='area_text_right' v-html='item.message'></div>
								<img :src="require('@/image/subscr/kefu.png')" alt="" class='marngin_img'
									style="margin: 0;">
								<div class='at_time' v-text='item.time'></div>
								<br>
							</div>
					
						</div>
					</div>
					<div style="height: 10.5rem;padding: .5rem 1rem 1rem;">
						<div id='t_text'>
							<div style='width: 100%;display:flex;justify-content: space-between;position: relative;'>
								<div class='marngin_tre'>
									<a-popover placement="top" :destroyTooltipOnHide="true" trigger="click"
										:overlayStyle="{width:'calc(24rem)'}"
										:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
										<template slot="content">
											<emotion @emotion="handleEmotion" :class = "[isCreated ? 'biaoqing2' : 'biaoqing1']"></emotion>
										</template>
										<img :src="require('@/image/subscr/sim.png')" alt="">
									</a-popover>
									<a-upload :before-upload="beforeUpload" method='post'
										:show-upload-list="false" :action="$api.uploadImage" :headers="headers"
										@change="handleChange">
										<img :src="require('@/image/subscr/img_s.png')" alt="">
									</a-upload>
									<img :src="require('@/image/subscr/an_qu.png')" alt="" @click='ismodal = true'>
								</div>
								<div class='two_btn'>
									<div @click='handdaigenjin'>待跟進</div>
									<div @click='handend1' v-if='params.showreadycloseflag == 1'>結束提醒</div>
									<div @click='handend' v-if='params.showcloseflag == 1'>結束對話</div>
									<div @click='getpush()'>發送消息</div>
								</div>
							</div>
							<a-textarea style='resize: none;' v-model="isvalue" placeholder=" " @keydown='handenter' :auto-size="{ minRows: 6, maxRows: 6 }" />
						</div>
					</div>

				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
			<handcaozuo v-if='ismodal' @child='ismodal=false'></handcaozuo>
			<div id='handimg-back' v-if='imgurl' @click='imgurl = ""'>
				<img :src="imgurl" alt="">
			</div>
		</a-modal>
	</div>
</template>

<script>
	import socketio from "socket.io-client";
	import App from '@/assets/app.js';
	import emotion from './Emotion/index.vue'
	import handcaozuo from './handcaozuo'
	
	export default {
		props: ['items'],
		components: {
			emotion,
			handcaozuo
		},
		data() {
			return {
				username:'',
				imgurl:'',
				headers: {},
				ismodal: false,
				show: false,
				isCreated: false,
				isrit_div: 0,
				isvalue: '',
				roomid: '',
				tablelist: [],
				tablist: [],
				ishand: false,
				visible: true,
				params:{},
				form: {
					"systemservice": "", //服務系統
					"supplier": "", //供應商
					"ip": "", //域名綁定ip
					"register_date": "", //註冊日期
					"expire_date": "", //到期日期
					"system_type": "", //域名類型
					"remark": "", //備註
					revisitLogList: []
				},
			}
		},
		watch: {},
		mounted() {
			this.roomid = this.items.roomid
			this.getlist()
		},
		methods: {
			onSearch(){
				this.getlist()
			},
			handleChange(info) {
			  // if (info.file.status !== 'uploading') {
			    // this.params[name].splice(ind - 1, 0, info.file.response.id);
			  // }
			  if (info.file.status === 'done') {
			    this.$message.success('上傳成功！');
				var str =
				        '<img src="' +
				        info.file.response.picurl +
				        '" align="middle" height="auto" width="120px"/>';
						
				this.$emit("childval", {
					'msg': str,
					'msgtype':1,
					'imgurl':info.file.response.picurl,
					'roomid': this.roomid,
				});
				var tdate = new Date()
				var t_timne = tdate.getHours() + ':' + (tdate.getMinutes()<10?'0'+tdate.getMinutes():tdate.getMinutes())+':'+tdate.getSeconds();
				var t_day = tdate.toLocaleDateString().split('/').join('-');
				this.tablelist.push({
					time: t_timne,
					dateval: t_day,
					type: 1,
					message: str,
					msgtype:1,
					imgurl:info.file.response.picurl
				})
				setTimeout(() => {
					var div = document.getElementById('scrolldIV');
					div.scrollTop = div.scrollHeight;
				}, 100)	
			  } else if (info.file.status === 'error') {
			    this.$message.error('上傳失敗！');
			  }
			  // this.$refs['imglist'].play()
			},
			beforeUpload(file) {
				// return new Promise((resolve, reject) => {
				// 	const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' //这里获取上传文件的类型
				// 	if (!isJpgOrPng) {
				// 		this.$message.warning('請上傳jpg/png圖片')
				// 		return reject(false); //如有问题那咱们通过reject 函数传一个false阻止他的上传
				// 	}
				// 	const isLt2M = file.size / 1024 / 1024 < 2;
				// 	if (!isLt2M) {
				// 		this.$message.error('圖片大小不能超過2M!');
				// 	}
				//  return isJpgOrPng && isLt2M;
				// });
				
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				      if (!isJpgOrPng) {
				        this.$message.error('You can only upload JPG file!');
				      }
				      const isLt2M = file.size / 1024 / 1024 < 2;
				      if (!isLt2M) {
				        this.$message.error('Image must smaller than 2MB!');
				      }
				      return isJpgOrPng && isLt2M;
			},
			redaytoshow(str) {
				var i = str.search(/emojj:[\u4E00-\u9FA5]{1,3}|emojj:OK|emojj:NO\;/gi);
				var a;
				while (i >= 0) {
					a = str.substring(i, str.indexOf(";", i) + 1);
					var b = str.length;
					str = str.replace(a, this.emotion(a));
					var c = str.length;
					if (b == c) {
						return str;
					}
			 	i = str.search(/emojj:[\u4E00-\u9FA5]{1,3}|emojj:OK|emojj:NO\;/gi);
				}
				return str;
			},
			emotion(res) {
				let word = res.replace(/\emojj:|\;/gi, "");
				const list = [
					"微笑",
					"撇嘴",
					"色",
					"发呆",
					"得意",
					"流泪",
					"害羞",
					"闭嘴",
					"睡",
					"大哭",
					"尴尬",
					"发怒",
					"调皮",
					"呲牙",
					"惊讶",
					"难过",
					"酷",
					"冷汗",
					"抓狂",
					"吐",
					"偷笑",
					"可爱",
					"白眼",
					"傲慢",
					"饥饿",
					"困",
					"惊恐",
					"流汗",
					"憨笑",
					"大兵",
					"奋斗",
					"咒骂",
					"疑问",
					"嘘",
					"晕",
					"折磨",
					"衰",
					"骷髅",
					"敲打",
					"再见",
					"擦汗",
			  		"抠鼻",
					"鼓掌",
					"糗大了",
					"坏笑",
					"左哼哼",
					"右哼哼",
					"哈欠",
					"鄙视",
					"委屈",
					"快哭了",
					"阴险",
					"亲亲",
					"吓",
					"可怜",
					"菜刀",
					"西瓜",
					"啤酒",
					"篮球",
					"乒乓",
					"咖啡",
					"饭",
					"猪头",
					"玫瑰",
					"凋谢",
					"示爱",
					"爱心",
					"心碎",
			  		"蛋糕",
					"闪电",
					"炸弹",
					"刀",
					"足球",
					"瓢虫",
					"便便",
					"月亮",
					"太阳",
			 		"礼物",
			  		"拥抱",
					"强",
					"弱",
					"握手",
					"胜利",
					"抱拳",
					"勾引",
					"拳头",
					"差劲",
					"爱你",
			  		"NO",
					"OK",
					"爱情",
					"飞吻",
					"跳跳",
					"发抖",
					"怄火",
					"转圈",
			 		"磕头",
					"回头",
					"跳绳",
					"挥手",
					"激动",
					"街舞",
					"献吻",
					"左太极",
					"右太极"
				];
				let index = list.indexOf(word);
				if (index < 0) {
					return word;
				}
				return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="middle">`;
			},
			handend1(){
				this.$ajax({
					method:'post',
					url:this.$api.readyToCloseRoom,
					data:{
						roomid:this.roomid
					}
				}).then(res=>{
					if(res.data.qmiscode == 1000){
						this.isrit_div = 0
						this.roomid = this.tablist[0]['roomid']
						this.getlist()
						setTimeout(()=>{
							this.$emit('child', 0)
						})
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
				
			},
			handend() {
				this.$ajax({
					method: 'post',
					url: this.$api.closeTalkRoom,
					data: {
						roomid: this.roomid
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.isrit_div = 0
						this.roomid = this.tablist[0]['roomid']
						this.getlist()
						setTimeout(() => {
							this.$emit('child', 0)
						})
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			getshua(data) {
				this.getlist()
			},
			handenter(ev) {
				if (ev.keyCode == 13) {
					this.getpush()
				}
			},
			//表情
			handleEmotion(i) {
				this.isvalue += i;
			},
			handis(i) {
				this.isrit_div = i
				this.roomid = this.tablist[i]['roomid']
				this.tablist[i]['noreadnum']= ''
				this.getdata(this.roomid)
			},
			getlist() {
				this.$ajax({
					method: 'post',
					url: this.$api.RoomInUse,
					data: {
						username:this.username
					
					}
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.tablist = res.data.result
						if (this.tablist.length) {
							this.tablist.map((val,i)=>{
								if(val.roomid == this.roomid){
									this.isrit_div = i
									val['noreadnum']= ''
								}
							})
							this.getdata(this.roomid)
						}
					}
				})
			},
			getpush() {
				this.isvalue=this.isvalue.trim()
				this.params.showcloseflag = 1
				if(this.isvalue){
					var tdate = new Date()
					var seconds = tdate.getSeconds()<10?'0' + tdate.getSeconds():tdate.getSeconds();
					var Hours = tdate.getHours()<10?'0' + tdate.getHours():tdate.getHours();
					var minutes =  tdate.getMinutes()<10?'0' + tdate.getMinutes():tdate.getMinutes();
					var t_timne = Hours + ':' + minutes +':' + seconds;
					var t_day = tdate.toLocaleDateString().split('/').join('-')
					let str = this.redaytoshow(this.isvalue)
					this.$emit("childval",{
						'roomid': this.roomid,
						'msg': this.isvalue
					});
					// console.log(str,this.isvalue)
					// this.tablelist.push({
					// 	time: t_timne,
					// 	dateval: t_day,
					// 	type: 1,
					// 	message: str,
					// })
					let _this = this
					setTimeout(() => {
						_this.getdata()
						_this.isvalue = ''
						setTimeout(() => {
							var div = document.getElementById('scrolldIV');
							div.scrollTop = div.scrollHeight;
						}, 100)
					}, 200)
				}
			},
			handdaigenjin(){
				this.$ajax({
					method: 'post',
					url: this.$api.beFollowedRoom,
					data: {
						roomid: this.roomid
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.isrit_div = 0
						this.roomid = this.tablist[0]['roomid']
						this.getlist()
						setTimeout(() => {
							this.$emit('child', 0)
						})
					}
				})
			},
			getdata(roomid = this.roomid) {
				this.$ajax({
					method: 'post',
					url: this.$api.getTalkingRecord,
					data: {
						"roomid": roomid
					}
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						let arr = []
						res.data.list.map(ev=>{
							if(arr.indexOf(ev.dateval) == -1){
								arr.push(ev.dateval)
								ev['state_l'] = true
							}
						})
						this.tablelist =[]
						this.tablelist = res.data.list
						this.params = res.data
						this.isvalue = ''
						setTimeout(() => {
							var div = document.getElementById('scrolldIV');
							div.scrollTop = div.scrollHeight;
						}, 100)
					}
				})
			},
			handb(item){
				this.imgurl = item.imgurl
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>
<style scoped>
	@import '../../../font/font.css';
	
	*,*::before,*::after{
	    box-sizing: border-box;
	    margin: 0;
	    padding: 0;
	    font-family:  "myFont","Microsoft JhengHei",sans-serif;
	}
	.marngin_img {
		width: 2rem;
	}
	.at_time{
		 position: absolute;
		 bottom: 0px;
		 right: 3.2rem;;
		 padding: 0px;   
	}
	.bt_time{
		position: absolute;
		bottom: 0px;
		    right: 0.2rem;
		padding: 0px;   
	}
</style>
<style lang='scss' scoped>
	#handimg-back {
		position: fixed;
		width: 100vw;
		height: 100vh;
		left: 0vw;
		top: 0vh;
		background-color: rgba(0, 0, 0, 0.45);
		z-index: 99;
		padding: 3rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	#handimg-back img{
		    width: auto;
		    height: auto;
		    max-width: 100%;
		    max-height: 100%;  
	}
</style>
<style lang="scss">
	#customerchat .ant-modal-header,
	#customerchat .ant-modal-body {
		background-color: #fff !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#customerchat {
		.marngin_tre img {
			cursor: pointer;
			width: 1.3rem;
			margin-right: 1rem;
		}
		
		.two_btn {
			display: flex;
			justify-content: space-between;
		}
		
		.two_btn div {
			border: 1px solid #3bc7a1;
			color: #3bc7a1;
			font-size: .8rem;
			border-radius: 8px;
			margin-left: 1rem;
			padding: .2rem;
			width: 4rem;
			text-align: center;
			cursor: pointer;
		}
		
		#t_text textarea {
			outline: none;
			border: none !important;
			box-shadow: 0 0 0 #fff !important;
		}
		
		.right_div {
			// border-bottom: 1px solid #f1f1f1;
			padding: .8rem;
		}
		
		.area_text {
			color: #333;
			background-color: #e8e8e8;
			border-radius: 4px;
			display: inline-block;
			// margin-left: 1rem;
			padding: .5rem;
			vertical-align: top;
			text-align: left;
			font-size: .8rem;
			padding: 8px 14px 20px 8px;
			min-width: 100px;
			width: 100%;
		}
		
		.area_text:after {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
			border: 7px solid;
			border-color: transparent #e8e8e8 transparent transparent;
			left: -0.7rem;
			top: .4rem;
		}
		
		.area_text_right {
			color: #333;
			background-color: #e6feda;
			border-radius: 4px;
			display: inline-block;
			margin-right: 1rem;
			padding: .5rem;
			max-width: 43%;
			vertical-align: top;
			text-align: left;
			font-size: .8rem;
			padding: 8px 14px 20px 8px;
			min-width: 100px;
		}
		
		.area_text_right:after {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
			border: 7px solid;
			border-color: transparent transparent transparent #e6feda;
			right: 2.3rem;
			top: .5rem;
		}
		
		.mark-file {
			position: absolute;
			top: 0;
			left: 0;
		
			// div {
			// 	width: 6rem;
			// 	font-size: 1rem;
			// 	padding: .5rem 1rem;
			// 	display: inline-block;
			// }
		}
		.ant-modal {
			top: 13vh;
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
			color: #000000;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				font-size: .8rem;
			}

			.f {
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 0rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
	
	#customerchat .ant-modal-close-x .anticon svg {
	    top: 1rem !important;
	    right: 0 !important;
	}
	
	@media screen and (min-width: 1921px){
		#customerchat .ant-modal-close-x .anticon svg {
		    top: 1rem !important;
		    right: 0 !important;
		}
		
		#customerchat .area_text:after {
			left: 2.5rem;
		}
		
		#customerchat .area_text_right:after {
			right: 2.5rem;
		}
	}
	
</style>
